// extracted by mini-css-extract-plugin
export default {"highlight":"highlight-W3gu","note":"note-Qqi9"};